// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".be9b420edc8a906e6cdc58987bfd4f4c.js";
};